import {
  Button,
  Card,
  Divider,
  Empty,
  Form,
  Input,
  PageHeader,
  Select,
  Typography,
} from "antd";
import { Option } from "antd/lib/mentions";
import moment from "moment";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { translation } from "../../../i18n/translationConstant";
import {
  createNewGrievance,
  getGrievanceIssuesTypes,
  getGrievanceOfUser,
} from "../../../Services/GrievanceServices/GrievanceService";
import Empty_State from "../../../Assets/empty_state.png";
import Report_Icon from "../../../Assets/report_issue_icon.png";

import "./index.css";
import { defaultPageSize } from "../../../Utils/Constants/apiConstants";
import useINF from "../../Common/Components/InfiniteScroll";
import CommonModal from "../../Common/Components/CommonModal";
import { ArrowLeftOutlined } from "@ant-design/icons";
import { useHistory } from "react-router-dom";

const Grievance: React.FC = () => {
  const { TextArea } = Input;
  const { t } = useTranslation();
  const [grievance, setGrievance] = useState([]);
  const [page, setPage] = useState(1);
  const pageSize = defaultPageSize;
  const [visible, setVisibility] = useState(false);
  const [grievanceIssues, setGrievanceIssues] = useState<any>({});
  const [form] = Form.useForm();
  const [isTicketDetailaModalVisible, setIsTicketDetailaModalVisible] =
    useState(false);
  const history = useHistory();
  const [selectedTicket, setSetectedTicket] = useState({
    createdOn: "",
    description: "",
    feedback: "",
    id: "",
    issueType: "",
    status: "",
    vuaId: "",
  });
  const [hasMore, setHasMore] = useState(true);

  const observer = useRef<any>();

  const { newObserver, ref } = useINF(observer, hasMore, setPage);

  observer.current = newObserver.current;

  const getGrievanceOfUserLocal = useCallback(() => {
    getGrievanceOfUser(page - 1, pageSize)
      .then((res) => res.data)
      .then((res) => {
        setHasMore(!res.last);

        setGrievance((old) => old.concat(res.content));
      });
  }, [page, pageSize]);

  useEffect(() => {
    getGrievanceOfUserLocal();
  }, [getGrievanceOfUserLocal]);

  const showModal = () => {
    setVisibility(true);
  };

  const handleCancel = (e: any) => {
    setVisibility(false);
  };

  const onDetailsEntered = (values: any) => {
    createNewGrievance(values).then(() => {
      setVisibility(false);
      setGrievance([]);
      getGrievanceOfUserLocal();
      form.resetFields();
    });
  };

  const showDetailsModal = (g: any) => {
    setSetectedTicket({
      createdOn: g.createdOn,
      description: g.description,
      feedback: g.feedback,
      id: g.id,
      issueType: g.issueType,
      status: g.status,
      vuaId: g.vuaId,
    });
    setIsTicketDetailaModalVisible(true);
  };

  const goBack = () => {
    history.goBack();
  };

  return (
    <div className="grievanceRoot">
      <CommonModal
        visible={isTicketDetailaModalVisible}
        onCancel={() => setIsTicketDetailaModalVisible(false)}
      >
        <div className="col alignCenter marginTop40 marginBottom40">
          <Typography.Text className="font20 fontWeight700">
            {selectedTicket.issueType}
          </Typography.Text>

          <div className="row spaceBetween marginTop40 width90">
            <div className="col width45">
              <Typography.Text className="detailsHeader">
                {t("lbldescription")}
              </Typography.Text>
              <Typography.Text className="detailsBody">
                {selectedTicket.description}
              </Typography.Text>
            </div>
            <div className="col  width45">
              <Typography.Text className="detailsHeader">
                {t("lblfeedback")}
              </Typography.Text>
              <Typography.Text className="detailsBody">
                {selectedTicket.feedback
                  ? selectedTicket.feedback
                  : t("lblNoFeedback")}
              </Typography.Text>
            </div>
            <div className="col  width45">
              <Typography.Text className="detailsHeader">
                {t("Transaction Id")}
              </Typography.Text>
              <Typography.Text className="detailsBody">
                {selectedTicket.id}
              </Typography.Text>
            </div>
            <div className="col width45">
              <Typography.Text className="detailsHeader">
                {t("Vua ID")}
              </Typography.Text>
              <Typography.Text className="detailsBody">
                {selectedTicket.vuaId}
              </Typography.Text>
            </div>
          </div>

          <div className="col alignCenter ">
            <div>
              <Typography.Text className="fontWeight600 font12 marginTop10 ">
                {moment(selectedTicket.createdOn).format("DD MMMM YYYY") +
                  " | " +
                  moment(selectedTicket.createdOn).format("LT")}
              </Typography.Text>
            </div>
            <div className="row">
              <Typography.Text>{t("lblStatus")}</Typography.Text>
              <Typography.Text className="statusType">
                {selectedTicket.status.charAt(0) +
                  selectedTicket.status.slice(1).toLowerCase()}
              </Typography.Text>
            </div>
          </div>
        </div>
      </CommonModal>
      <CommonModal visible={visible} onCancel={handleCancel}>
        <div className="col alignCenter">
          <Typography.Text className="font24 fontWeight600 marginTop10">
            {t("lblReportIssue")}
          </Typography.Text>

          <Form
            form={form}
            name="basic"
            onFinish={onDetailsEntered}
            autoComplete="off"
            scrollToFirstError={true}
            className="generateTicketForm"
          >
            <Form.Item
              name={"issueType"}
              rules={[
                {
                  required: true,
                  message: t("lblRequiredField"),
                },
              ]}
            >
              <Select
                placeholder="Select type of Issue"
                className="issueSelector"
                loading={Object.keys(grievanceIssues).length === 0}
                // tslint:disable-next-line: jsx-no-lambda
                onDropdownVisibleChange={(open) => {
                  if (open && Object.keys(grievanceIssues).length === 0) {
                    getGrievanceIssuesTypes()
                      .then((res) => res.data)
                      .then((res) => {
                        setGrievanceIssues(res);
                        // tslint:disable-next-line: no-console
                      });
                  }
                }}
              >
                {Object.keys(grievanceIssues)
                  .sort()
                  .map((key, index) => (
                    <Option key={index.toString()} value={key}>
                      {grievanceIssues[key]}
                    </Option>
                  ))}
              </Select>
            </Form.Item>
            <Form.Item
              name={"description"}
              rules={[
                {
                  required: true,
                  message: t("lblRequiredField"),
                },
              ]}
            >
              <TextArea
                className="marginTop10 ticketDescription"
                placeholder={t("reportdescription")}
                autoSize={{ minRows: 4 }}
              />
            </Form.Item>
            <div className="row justifyCenter">
              <Button
                className="font16 fontWeight600 ticketsubmit "
                htmlType="submit"
              >
                {t("lblReportIssue")}
              </Button>
            </div>
          </Form>
        </div>
      </CommonModal>
      <div className="grievanceheader">
        {/* <Typography.Text className="font24 fontWeight600">
          {t("lblReportIssue")}
        </Typography.Text>

        <Button className="reportButton" type="primary" onClick={showModal}>
          {t("lblAddIssue")}
        </Button> */}
        <PageHeader
          className="linkAccountTitle"
          backIcon={<ArrowLeftOutlined className="backIcon" onPointerOverCapture={undefined} onPointerMoveCapture={undefined}/>}
          onBack={goBack}
          extra={
            <Button
              className="reportButton"
              type="primary"
              onClick={showModal}
            >
              {t("lblAddIssue")}
            </Button>
          }
          title={t("lblReportIssue")}
        />
      </div>
      <Divider />
      <div className="grievanceHome">
        {grievance && grievance.length ? (
          <>
            {grievance.map((g: any, index: number) => (
              <Card
                key={index}
                hoverable={true}
                className="cardStyles width100"
                onClick={() => showDetailsModal(g)}
              >
                <div className="row spaceBetween alignCenter">
                  <div className="flex40 row alignCenter">
                    <div className="avatarBG size56">
                      <img src={Report_Icon} alt="" className="size32" />
                    </div>
                    <Typography.Text className="fontWeight600 marginLeft10">
                      {t(g.issueType)}
                    </Typography.Text>
                  </div>
                  <div className="row spaceBetween flex60">
                    <div>
                      <Typography.Text className="fontWeight600 font12">
                        {t("Transaction ID") + " : "}
                      </Typography.Text>

                      <Typography.Text className="font12">
                        {g.id}
                      </Typography.Text>
                    </div>
                    <div>
                      <Typography.Text className="fontWeight600 font12">
                        {moment(g.createdOn).format("DD MMMM YYYY") +
                          " | " +
                          moment(g.createdOn).format("LT")}
                      </Typography.Text>
                    </div>
                  </div>
                </div>
              </Card>
            ))}
            <div ref={ref} className="infiniteDiv" />
          </>
        ) : (
          <Empty
            image={Empty_State}
            description={
              <Typography.Text className="noAccountFound">
                {t(translation.lblIssuesFound)}
              </Typography.Text>
            }
          />
        )}
      </div>
    </div>
  );
};

export default Grievance;
